module.exports = __webpack_public_path__ + "assets/a-shuben4.071f8934.svg";